// extracted by mini-css-extract-plugin
export default {"admin_contain":"Admin_admin_contain__zVTQh","admin_wrap":"Admin_admin_wrap__l-pWy"};